import DateRangePicker from "components/wps/DateRangePicker";
import { useEffect, useState } from "react";
import { Option } from "@material-tailwind/react";
import {
  Button,
  Typography,
  Popover,
  PopoverHandler,
  PopoverContent,
} from "@material-tailwind/react";
import { SearchIcon } from "@heroicons/react/outline";
import Select from "react-select";

const FilterGroup = (props: any) => {
  const { isMobile, openSearchBox, setOpenSearchBox, translate, search, setSearch, setFilter, setApplyDate, setPage, applyDate } = props;
  const status_list = [
    {
      value: '',
      label: translate('all-status')
    },
    {
      value: true,
      label: translate('active')
    },
    {
      value: false,
      label: translate('in-active')
    },
  ];

  const [status, setStatus] = useState('');

  useEffect(() => {
    if (search.status !== '') {
      status_list.forEach((item: any) => {
        if (item.value.toString() === search.status) {
          setStatus(item.value);
        }
      });
    } else {
      setStatus('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleChangeSearchValue = (value: any, type: string) => {
    const values = { ...search } as any;

    values[type] = value;

    if (type === 'status') {
      setStatus(value);
    }

    setSearch({ ...values });
  }

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      setFilter(true);
    }
  };

  if (!isMobile) {
    return (
      <div className={`${isMobile ? 'p-[16px] grid grid-cols-1 gap-[12px]' : 'p-[24px] grid grid-cols-2 gap-[12px] flex items-end'} w-full rounded-[8px] bg-white`} onKeyDown={handleKeyDown}>
        <div className="w-full">
          <div className="text-14 font-500 mb-[8px]">{translate('search')}</div>

          <input className="w-full h-[40px] rounded-[4px] border border-[#C5CCD2]" placeholder={translate("placeholder-search-role")}
            onChange={(e: any) => handleChangeSearchValue(e.target.value, 'q')} value={search.q} />
        </div>

        <div className="w-full">
          <div className="text-14 font-500 mb-[8px]">{translate('created-date')}</div>
          <DateRangePicker
            quickSelectDate={true}
            applyDate={applyDate}
            setApplyDate={setApplyDate}
          />
        </div>

        <div className="w-full">
          <div className="text-14 font-500 mb-[8px]">{translate('status')}</div>

          <div className='select-role'>
            <Select
              styles={{
                input: (base) => ({
                  ...base,
                  "input:focus": {
                    boxShadow: "none",
                  },
                })
              }}
              name="ticket_platform"
              options={status_list}
              className="filter-item__select"
              classNamePrefix="select"
              placeholder={status_list[0].label}
              onChange={(e: any) => {
                handleChangeSearchValue(e.value, 'status');
              }} />
          </div>
        </div>

        <Button
          onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
          onResizeCapture={() => { }}
          placeholder="button filter account" className="h-[40px] w-[140px] flex items-center justify-center bg-brand-500" onClick={() => {
            setFilter(true);
            setPage(1);
          }}>
          <SearchIcon className="size-[16px] text-white" />

          <span className="text-white text-14 font-500">{translate('search')}</span>
        </Button>
      </div>
    )
  } else {
    return (
      <Popover placement="bottom" open={openSearchBox} handler={setOpenSearchBox} >
        <PopoverHandler>
          <div className="btn-search">
            <SearchIcon className="w-7 h-7" />
          </div>
        </PopoverHandler>
        <PopoverContent
          onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
          onResizeCapture={() => { }}
          className="w-96 !left-[16px]" placeholder="PopoverContent">
          <Typography
            onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
            onResizeCapture={() => { }}
            className="!text-14 font-500 mb-[8px]" placeholder="Typography">
            {translate('search')}
          </Typography>

          <input className="w-full rounded-[4px] border-[#d1d5db] text-14 mb-[16px]"
            onChange={(e: any) => handleChangeSearchValue(e.target.value, 'q')}
            placeholder={translate('placeholder-search-role')}
            value={search.q} />

          <Typography
            onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
            onResizeCapture={() => { }}
            className="!text-14 font-500 mb-[8px]" placeholder="Typography">
            {translate('created-date')}
          </Typography>

          <div className="mb-[16px]">
            <DateRangePicker
              mobile={isMobile}
              quickSelectDate={true}
              applyDate={applyDate}
              setApplyDate={setApplyDate}
            />
          </div>

          <Typography
            onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
            onResizeCapture={() => { }}
            className="!text-14 font-500 mb-[8px]" placeholder="Typography">
            {translate('status')}
          </Typography>

          <div className='select-role'>
            <Select
              name="ticket_platform"
              options={status_list}
              className="filter-item__select"
              classNamePrefix="select"
              placeholder={status_list[0].label}
              onChange={(e: any) => {
                handleChangeSearchValue(e.value, 'status');
              }} />
          </div>

          <Button
            onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
            onResizeCapture={() => { }}
            placeholder="button filter account" className="w-full h-[40px] bg-brand-500 flex items-center justify-center mt-[16px]" onClick={() => {
              setFilter(true);
              setOpenSearchBox(false);
              setPage(1);
            }}>
            <SearchIcon className="size-[16px] text-white" />

            <span className="text-14 text-white">{translate('search')}</span>
          </Button>
        </PopoverContent>
      </Popover>
    )
  }

}

export default FilterGroup;